export default "__VITE_ASSET__10a5357d__"